"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
const expressions_1 = require("@mwater/expressions");
const expressions_ui_1 = require("@mwater/expressions-ui");
const react_1 = __importStar(require("react"));
const ActionCancelModalComponent_1 = __importDefault(require("@mwater/react-library/lib/ActionCancelModalComponent"));
const ui = __importStar(require("@mwater/react-library/lib/bootstrap"));
const uuid_1 = __importDefault(require("uuid"));
const valueFormatter_1 = require("../valueFormatter");
const valueFormatter_2 = require("../valueFormatter");
function EditHoverOver(props) {
    const { schema, dataSource, design, onDesignChange, table } = props;
    const [editing, setEditing] = (0, react_1.useState)(false);
    const [draftItems, setDraftItems] = (0, react_1.useState)(undefined);
    const handleRemovePopup = () => {
        const newDesign = (0, lodash_1.omit)(design, "hoverOver");
        onDesignChange(newDesign);
    };
    const handleItemChange = (item) => {
        setDraftItems(draftItems?.map((i) => (item.id === i.id ? item : i)));
    };
    const handleItemDelete = (item) => {
        setDraftItems(draftItems?.filter((i) => item.id !== i.id));
    };
    const handleAddItem = () => {
        setDraftItems([...(draftItems ?? []), { id: (0, uuid_1.default)().replace(/-/g, ""), label: "" }]);
    };
    const handleSave = () => {
        const hoverOver = { ...(design.hoverOver ?? {}), items: draftItems ?? [] };
        const newDesign = { ...design, hoverOver };
        onDesignChange(newDesign);
        setEditing(false);
        setDraftItems(undefined);
    };
    const handleCancel = () => {
        setEditing(false);
        setDraftItems(undefined);
    };
    const handleOpen = () => {
        setDraftItems(design.hoverOver?.items ?? []);
        setEditing(true);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("button", { className: "btn btn-link", onClick: handleOpen },
            react_1.default.createElement("span", { className: "fa fa-pencil" }),
            " ",
            T `Customize Hoverover`),
        design.hoverOver && (react_1.default.createElement("button", { className: "btn btn-link", onClick: handleRemovePopup },
            react_1.default.createElement("span", { className: "fa fa-times" }),
            " ",
            T `Remove Hover over`)),
        editing && (react_1.default.createElement(ActionCancelModalComponent_1.default, { onAction: handleSave, onCancel: handleCancel, actionLabel: T `Save`, title: T `Customize Hoverover`, size: "x-large" },
            (draftItems ?? []).length > 0 && (react_1.default.createElement("table", { className: "table" },
                react_1.default.createElement("thead", null,
                    react_1.default.createElement("tr", null,
                        react_1.default.createElement("th", null, T `Label`),
                        react_1.default.createElement("th", null, T `Value`),
                        react_1.default.createElement("th", { style: { width: "1%", whiteSpace: "nowrap" } }, T `Format`),
                        react_1.default.createElement("th", { style: { width: "1%", whiteSpace: "nowrap" } }))),
                react_1.default.createElement("tbody", null, draftItems?.map((item) => (react_1.default.createElement(HoverOverItemEditor, { key: item.id, schema: schema, dataSource: dataSource, table: table, onItemChange: handleItemChange, onItemDelete: handleItemDelete, item: item })))))),
            react_1.default.createElement("button", { className: "btn btn-link", onClick: handleAddItem },
                react_1.default.createElement("span", { className: "fas fa-plus me-1" }),
                T `Add Item`)))));
}
function HoverOverItemEditor(props) {
    const { schema, dataSource, table, item, onItemChange, onItemDelete } = props;
    function renderFormat() {
        const exprUtils = new expressions_1.ExprUtils(schema);
        const exprType = exprUtils.getExprType(item.value ?? null);
        if (!exprType) {
            return null;
        }
        if (!(0, valueFormatter_1.canFormatType)(exprType)) {
            return null;
        }
        const formats = (0, valueFormatter_2.getFormatOptions)(exprType);
        if (!formats) {
            return null;
        }
        return (react_1.default.createElement(ui.Select, { options: formats.map(f => ({ value: f.value, label: f.label })), value: item.format ?? (0, valueFormatter_1.getDefaultFormat)(exprType), onChange: value => onItemChange({ ...item, format: value ?? undefined }), style: { width: "auto", display: "inline-block" } }));
    }
    return (react_1.default.createElement("tr", null,
        react_1.default.createElement("td", { className: "align-middle" },
            react_1.default.createElement(ui.TextInput, { value: item.label, onChange: value => onItemChange({ ...item, label: value }) })),
        react_1.default.createElement("td", { className: "align-middle" },
            react_1.default.createElement(expressions_ui_1.ExprComponent, { schema: schema, dataSource: dataSource, table: table, types: ["text", "number", "enum", "boolean", "date", "datetime", "id"], onChange: expr => onItemChange({ ...item, value: expr }), value: item.value ?? null, aggrStatuses: ["individual", "literal", "aggregate"] })),
        react_1.default.createElement("td", { className: "align-middle", style: { width: "1%", whiteSpace: "nowrap" } }, renderFormat()),
        react_1.default.createElement("td", { className: "align-middle", style: { width: "1%", whiteSpace: "nowrap" } },
            react_1.default.createElement("button", { className: "btn btn-link", onClick: () => onItemDelete(item) },
                react_1.default.createElement("span", { className: "fa fa-close" })))));
}
exports.default = EditHoverOver;
